import { postApiWebSession } from '/api/sdk.gen';

import type { AppDispatch, RootState } from '/business/shared/state/store';
import { sessionTTL } from '/shared/util/Statics';
import { clearAllErrors } from '/shared/state/actions/error';
import normaliseError, { toNormaliseErrorInput } from '/shared/functions/normaliseError';

const requestData = { ttl: sessionTTL, context: 'business' };

let debounce: Promise<void> | null = null;

const getSession = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  if (debounce) {
    return debounce;
  }

  debounce = (async () => {
    try {
      const { auth: authState } = getState();

      if (authState.fetching) {
        return;
      }

      await dispatch({ type: 'GET_SESSION_STARTED', timestamp: Date.now() });

      const { data } = await postApiWebSession({
        body: requestData,
      });

      if (!data) {
        throw new Error('No data from web_session response');
      }

      const { token, expires } = data;

      if (!token) {
        throw new Error('No token from web_session response');
      }
      if (!expires) {
        throw new Error('No expires from web_session response');
      }
      if (new Date(expires).getTime() - Date.now() <= 0) {
        throw new Error('Expiry is in the past');
      }

      await dispatch({ type: 'GET_SESSION_FULFILLED', token, expires });

      await dispatch(clearAllErrors());
    } catch (error) {
      await dispatch({ type: 'GET_SESSION_REJECTED', error: normaliseError(toNormaliseErrorInput(error), 'SESSION') });
      throw error;
    } finally {
      debounce = null;
    }
  })();

  return debounce;
};

export default getSession;
